import * as tslib_1 from "tslib";
import { MergeExcludeItem, } from '../../globalTypes';
import Router from '../util/routing/Router';
var settings = require('../../settings').settings;
var ContextCreator = /** @class */ (function () {
    function ContextCreator() {
    }
    ContextCreator.create = function (lturState, mergeExcludeList) {
        if (!lturState) {
            return settings.defaultProductContext;
        }
        var websiteState = lturState.websiteState;
        var cmsState = lturState.cmsState;
        var locationContextObject;
        if (typeof websiteState !== 'undefined' && websiteState.app.location) {
            locationContextObject = Router.getContextFromUrl(websiteState.app.location);
        }
        return tslib_1.__assign({}, settings.defaultProductContext, ((!mergeExcludeList || !mergeExcludeList.includes(MergeExcludeItem.LOCATION_CONTEXT_OBJECT))
            && locationContextObject && tslib_1.__assign({}, locationContextObject)), ((!mergeExcludeList || !mergeExcludeList.includes(MergeExcludeItem.CMS_STATE))
            && cmsState && cmsState.api.response && tslib_1.__assign({}, cmsState.api.response.settings.productSearch.context)));
    };
    return ContextCreator;
}());
export { ContextCreator };
export default ContextCreator;
